import { render, staticRenderFns } from "./system-notice.vue?vue&type=template&id=27d678b5"
import script from "./system-notice.vue?vue&type=script&lang=ts"
export * from "./system-notice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports